import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Menu,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  ListItemText,
  ListItemIcon,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import axios from "axios";
import { useAuth } from "../../../../AuthProvider";
import { useFormik } from "formik";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";

const AllClassSchedules = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A");

  // const [classSectionData, setClassSectionData] = useState([]);
  // const [classOptions, setClassOptions] = useState([]);
  // const [sectionOptions, setSectionOptions] = useState([]);

  const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState("Class-I");
const [sscSelectedSection, setSscSelectedSection] = useState("Section-A");

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
const [interSelectedSection, setInterSelectedSection] = useState("Section-A");
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

// const selectedClass= sscSelectedClass || interSelectedClass;
// const selectedSection = sscSelectedSection || interSelectedSection;



  // const [selectedDay, setSelectedDay] = useState("");
  const [selectedDay, setSelectedDay] = useState(() => {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const today = new Date().getDay(); // 0 (Sun) - 6 (Sat)
    return daysOfWeek[today];
  });
  

  const [allSchedules, setAllSchedules] = useState([]);

  const { userId, oId,board,pId, role  } = useAuth();
  const [tableData, setTableData] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const selectedClass = board === "INTERMEDIATE" ? interSelectedClass : sscSelectedClass;
const selectedSection = board === "INTERMEDIATE" ? interSelectedSection : sscSelectedSection;

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

    const [users, setUsers] = useState([]);
      const [selectedUsers, setSelectedUsers] = useState('');
      const isPrincipal = role?.startsWith("PRINCIPAL") || false;
      const UserId = userId || selectedUsers;
    
      useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch users');
                }
                const data = await response.json();
                setUsers(data);
                if (data.length > 0) {
                  setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
              }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, []);




// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      // setSscClassSectionData(data);
      const classes = data.map(item => item.classRegistration);
      setSscClassOptions(classes);

      let defaultClass = sscSelectedClass || (classes.includes("Class-I") ? "Class-I" : classes[0] || "");
      setSscSelectedClass(defaultClass);

      const defaultClassData = data.find(item => item.classRegistration === defaultClass);
      if (defaultClassData) {
        const sections = defaultClassData.sections.split(",");
        setSscSectionOptions(sections);
        setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
      } else {
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if(!UserId) return;
  if (!sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/classSchedule/getAllClassSchedulesWithDayname/${oId}/${pId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&dayName=${selectedDay}`
    );

    if (!response.ok) {
      console.error("Failed to fetch data. Status:", response.status);
      setFilteredData([]);
      return;
    }

    const data = await response.json();
    if (Array.isArray(data)) {
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcourses/${pId}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/classSchedule/getAllClassSchedulesWithDayname/${oId}/${pId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&dayName=${selectedDay}`
    );    
    
    if (!response.ok) {
      console.error("Failed to fetch data. Status:", response.status);
      setFilteredData([]);
      return;
    }

    const data = await response.json();
    if (Array.isArray(data)) {
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here


// SSC: When selected class changes, update its sections
useEffect(() => {
  const updateSectionOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
      const data = await response.json();
      if (response.ok && Array.isArray(data)) {
        const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
        if (selectedClassData) {
          const sections = selectedClassData.sections.split(",");
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
        } else {
          setSscSectionOptions([]);
          setSscSelectedSection("");
        }
      }
    } catch (error) {
      console.error("Error updating SSC sections:", error);
    }
  };

  if (board === "SSC" && sscSelectedClass) {
    updateSectionOptions();
  }
}, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);





// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection || !selectedDay) {
     
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType || !selectedDay) {
     
      setFilteredData([]);
      
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType,selectedDay,UserId]);







  // const fetchData = async () => {
  //   if (!oId || !baseUrl || !selectedClass || !selectedSection) return; // Prevent API call if values are missing

  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/classSchedule/getAllClassSchedulesWithDayname/${oId}?romanNumberClass=${encodeURIComponent(
  //         selectedClass
  //       )}&sections=${encodeURIComponent(selectedSection)}&dayName=${selectedDay}`
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log("API Response:", data); // ✅ Debug API Response

  //     // ✅ Adjusting check based on API response structure
  //     if (data && Array.isArray(data)) {
  //       setFilteredData(data); // ✅ Directly setting the array
  //     } else {
  //       console.warn("No data found:", data); // ✅ Log if empty
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setFilteredData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // ✅ Ensure API is called when dependencies change
  // useEffect(() => {
  //   fetchData();
  // }, [oId, baseUrl, selectedClass, selectedSection,selectedDay]);





  const exportToExcel = () => {
    const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";

    const processedData = filteredData.map(
      (
        { teacherId,teacherFirstName,teacherLastName, dayName, period, timeSlot,course, romanNumberClass, sections, subject },
        index
      ) => ({
        SNo: index + 1, // Serial number starts from 1
        TeacherID: teacherId,
        TeacherName: `${teacherFirstName} ${teacherLastName}`,
        Weekday: dayName,
        Period: period,
        Time: timeSlot,
        ...(isIntermediate ? { Course: course } : {}),
        [dynamicKey]: romanNumberClass,
        Section: sections,
        Subject: subject,
      })
    );

    const workbook = new ExcelJS.Workbook();
    // const worksheet = workbook.addWorksheet("ScheduleList");
    const worksheet = workbook.addWorksheet(
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection}_ScheduleList`
        : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList`
    );
    
    // Add headers
    worksheet.columns = [
      { header: "S.No", key: "SNo", width: 10 }, // Keep S.No as the first column
      { header: "Teacher ID", key: "TeacherID", width: 15 },
      { header: "Teacher Name", key: "TeacherName", width: 20 },
      { header: "Weekday", key: "Weekday", width: 25 },
      { header: "Period", key: "Period", width: 20 },
      { header: "Time", key: "Time", width: 30 },
      ...(board === "INTERMEDIATE"
        ? [{ header: "Course", key: "Course", width: 15 }]
        : []),
        { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
      
      { header: "Section", key: "Section", width: 15 },
      { header: "Subject", key: "Subject", width: 20 },
    ];

    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

   

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
       // Generate dynamic filename
 
    link.download = board === "INTERMEDIATE"
    ? `${interSelectedClass}-${interSelectedSection}_ScheduleList.xlsx`
    : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList.xlsx`;
     
      link.click();
    });

    handleExportClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const isIntermediate = board === "INTERMEDIATE";
  
    // Title settings
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
  

    const title = isIntermediate
      ? `${interSelectedClass}-${interSelectedSection} ScheduleList`
      : `${sscSelectedClass}-${sscSelectedSection} ScheduleList`;
    
    doc.text(title, 10, 8);
  
    // Define headers
    const headers = [
      "S.No",
      "Teacher ID",
      "Teacher Name",
      "Weekday",
      "Period",
      "Time",
      ...(board === "INTERMEDIATE" ? ["Course"] : []),
      isIntermediate ? "Year" : "Class",
      "Section",
      "Subject",
    ];
  
    // Define body
    const bodyData = filteredData.map((row, index) => {
      const baseRow = [
        index + 1,
        row.teacherId,
        `${row.teacherFirstName} ${row.teacherLastName}`,
        row.dayName,
        row.period,
        row.timeSlot,
      ];
  
      if (board === "INTERMEDIATE") {
        baseRow.push(row.course || "-");
      }
  
      baseRow.push(
        row.romanNumberClass,
        row.sections,
        row.subject
      );
  
      return baseRow;
    });
  
    // Table
    doc.autoTable({
      startY: 20,
      head: [headers],
      body: bodyData,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      columnStyles: {
        2:{ cellWidth: 20 }, 
        5: { cellWidth: 30 }, 
      },
      theme: "grid",
    });
  
    // Save the file
    const fileName = isIntermediate
      ? `${interSelectedClass}-${interSelectedSection}_ScheduleList.pdf`
      : `${sscSelectedClass}-${sscSelectedSection}_ScheduleList.pdf`;
  
    doc.save(fileName);

  
    handleExportClose();
  };
  


  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    if(board === "INTERMEDIATE") {
      link.download = `${interSelectedClass}-${interSelectedSection}_ScheduleList.json`;
    } else {
      link.download = `${sscSelectedClass}_${sscSelectedSection}_ScheduleList.json`;
    }
    // link.download = `${selectedClass}-${selectedSection}_StudentsList.json`;
    link.click();
    handleExportClose();
  };


  const headerStyle = {
    border: "1px solid #ddd",
    padding: "6px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    backgroundColor: "#fff9c4",
  };


  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          // height: "90vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", mb: 3, textAlign: "left" }}
          >
            All Class Schedules
          </Typography>

         <Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  flexWrap="wrap"
  mb={3}
  gap={2} // Optional, for spacing between left and right on small screens
>
  {/* Left Side: Form Controls */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap", // Allow wrapping if too many items on small screen
      gap: 1.5,
    }}
  >
    {board === "SSC" && (
      <>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="class-select-label">Select Class</InputLabel>
          <Select
            labelId="class-select-label"
            value={sscSelectedClass}
            onChange={(e) => setSscSelectedClass(e.target.value)}
            label="Select Class"
            sx={{ height: 35 }}
          >
            {sscClassOptions.map((cls) => (
              <MenuItem key={cls} value={cls}>
                {cls}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="section-select-label">Select Section</InputLabel>
          <Select
            labelId="section-select-label"
            value={sscSelectedSection}
            onChange={(e) => setSscSelectedSection(e.target.value)}
            label="Select Section"
            sx={{ height: 35 }}
            disabled={sscSectionOptions.length === 0}
          >
            {sscSectionOptions.map((section) => (
              <MenuItem key={section} value={section}>
                {section}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    )}

    {board === "INTERMEDIATE" && (
      <>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
          <Select
            labelId="intermediate-class-select-label"
            value={interSelectedClass}
            onChange={(e) => setInterSelectedClass(e.target.value)}
            label="Select Year"
            sx={{ height: 35 }}
          >
            <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
            <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="course-type-label">Select Course</InputLabel>
          <Select
            labelId="course-type-label"
            value={selectedCourseType}
            onChange={(e) => setSelectedCourseType(e.target.value)}
            label="Select Course"
            sx={{ height: 35 }}
          >
            {courseOptions.map((course, index) => (
              <MenuItem key={index} value={course}>
                {course}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
          <Select
            labelId="intermediate-section-select-label"
            value={interSelectedSection}
            onChange={(e) => setInterSelectedSection(e.target.value)}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {interSectionOptions.map((section, index) => (
              <MenuItem key={index} value={section}>
                {section}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    )}

    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="day-select-label">Select Day</InputLabel>
      <Select
        labelId="day-select-label"
        value={selectedDay}
        onChange={(e) => setSelectedDay(e.target.value)}
        label="Select Day"
        sx={{ height: 35 }}
      >
        <MenuItem value="Monday">Monday</MenuItem>
        <MenuItem value="Tuesday">Tuesday</MenuItem>
        <MenuItem value="Wednesday">Wednesday</MenuItem>
        <MenuItem value="Thursday">Thursday</MenuItem>
        <MenuItem value="Friday">Friday</MenuItem>
        <MenuItem value="Saturday">Saturday</MenuItem>
      </Select>
    </FormControl>

    {/* {isPrincipal && (
      <FormControl size="small" sx={{ width: 150 }}>
        <InputLabel>Select Schedule Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Schedule Admin"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )} */}
  </Box>

  {/* Right Side: Buttons */}
  <Box sx={{ display: "flex", gap: 1 }}>
    <Button
    size="small"
      variant="outlined"
      color="secondary"
      onClick={() =>
        navigate("/ClassTimeTable", {
          state: { selectedClass, selectedSection, selectedCourseType },
        })
      }
      sx={{
        minWidth: 100, // You can reduce this value as needed
        paddingX: 2,
        backgroundColor: "#6E69B0",
        color: "white",
        fontWeight: "bold",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: "#58548E",
        },
      }}
    >
      View Class TimeTable
    </Button>

    <Button
      variant="contained"
      onClick={handleExportClick}
      sx={{
        backgroundColor: "#6E69B0",
        color: "white",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#58548E",
        },
      }}
      startIcon={<PresentToAllIcon />}
    >
      Export
    </Button>
  </Box>

  {/* Export Menu */}
  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        },
      }}
    >
      <ListItemIcon sx={{ color: "#00796b" }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
    </MenuItem>

    <MenuItem
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        },
      }}
    >
      <ListItemIcon sx={{ color: "#d32f2f" }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
    </MenuItem>

    <MenuItem
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        },
      }}
    >
      <ListItemIcon sx={{ color: "#6a1b9a" }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: "bold", color: "#6a1b9a" }} />
    </MenuItem>
  </Menu>
</Box>


          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "480px",
              // height: "90%",
              overflow: "auto",
              marginTop: "20px",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerStyle}>S.No</TableCell>
                  <TableCell sx={headerStyle}>TeacherID</TableCell>
                  <TableCell sx={headerStyle}>Teacher Name</TableCell>
                  <TableCell sx={headerStyle}>Weekday</TableCell>
                  <TableCell sx={headerStyle}>Period</TableCell>
                  <TableCell sx={headerStyle}>Time</TableCell>
                  {(board === "INTERMEDIATE" ) && (
                 <TableCell sx={headerStyle}>Course</TableCell>
                  )}
                  <TableCell sx={headerStyle}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
                  <TableCell sx={headerStyle}>Section</TableCell>
                  <TableCell sx={headerStyle}>Subject</TableCell>
                  {/* <TableCell sx={headerStyle}>Action</TableCell> */}
                </TableRow>
              </TableHead>

              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      sx={{ textAlign: "center", padding: "20px" }}
                    >
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: "white",
                        "&:hover": { backgroundColor: "#f5f5f5" },
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.teacherId}
                      </TableCell>
                     <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "2px",
    textAlign: "center",
    maxWidth: "80px",
    minWidth: "80px",
  }}
>
  <Box
    sx={{
      whiteSpace: "normal",       // Allow wrapping
      wordBreak: "break-word",    // Break long words
      overflowWrap: "break-word",
      fontSize: "13px",
    }}
  >
    {row.teacherFirstName} {row.teacherLastName}
  </Box>
</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.dayName}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.period}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.timeSlot}
                      </TableCell>
                      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        {row.romanNumberClass}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px",
                          textAlign: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.subject}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AllClassSchedules;